module.exports = __webpack_public_path__ + "assets/img/veg_left.8b442e97.png";